import { render, staticRenderFns } from "./FeedbackCreate.vue?vue&type=template&id=5bf36f69&scoped=true"
import script from "./FeedbackCreate.vue?vue&type=script&lang=ts"
export * from "./FeedbackCreate.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackCreate.vue?vue&type=style&index=0&id=5bf36f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf36f69",
  null
  
)

export default component.exports